/**
 * Plain-data SEO manifest for use-case landing pages. Lives in its own file
 * (no JSX, no React imports) so `vite.config.ts` can import it from the
 * Node-config TypeScript project without pulling in the .tsx vertical
 * configs that include component-tree fragments.
 *
 * Vertical .tsx configs in `verticals/` import the matching entry here as
 * the single source of truth for title/description/ogImage.
 */
export interface UseCaseSeoEntry {
  slug: string;
  title: string;
  description: string;
  /** Root-relative path or absolute URL; the build plugin upgrades root-relative paths to absolute. */
  ogImage: string;
}

export const USE_CASE_SEO: Record<string, UseCaseSeoEntry> = {
  education: {
    slug: "education",
    title: "Forward Use Case: Year in Review for K–12",
    description:
      "Turn the data your school already tracks into a swipeable Year in Review. For schools, districts, and the education platforms that serve them.",
    ogImage: "/og/education.png",
  },
  "customer-marketing": {
    slug: "customer-marketing",
    title: "Forward Use Case: Year in Review for Customer Success",
    description:
      "Turn customer milestones into personalized narratives — Year in Review, onboarding, renewal, and beyond. Built for any team whose retention runs on relationships.",
    ogImage: "/og/customer-marketing.png",
  },
  "industry-reporting": {
    slug: "industry-reporting",
    title: "Forward Use Case: Research Reporting",
    description:
      "Turn your published research into interactive narratives that keep working all year — not just launch week.",
    ogImage: "/og/industry-reporting.png",
  },
  "local-government": {
    slug: "local-government",
    title: "Forward Use Case: Local Government",
    description:
      "Turn the report that justifies your program into a narrative residents actually finish, and bring back real reaction for your council, budget office, or funder.",
    ogImage: "/og/local-government.png",
  },
};

export function listUseCaseSeo(): UseCaseSeoEntry[] {
  return Object.values(USE_CASE_SEO);
}
